import { render } from "./tableAlerts.vue?vue&type=template&id=5d2245d0&scoped=true"
import script from "./tableAlerts.vue?vue&type=script&lang=js"
export * from "./tableAlerts.vue?vue&type=script&lang=js"

import "./tableAlerts.vue?vue&type=style&index=0&id=5d2245d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2245d0"]])

export default __exports__